import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconHyphen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.25 9C5.25 8.37868 5.75368 7.875 6.375 7.875H11.625C12.2463 7.875 12.75 8.37868 12.75 9C12.75 9.62132 12.2463 10.125 11.625 10.125H6.375C5.75368 10.125 5.25 9.62132 5.25 9Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconHyphen;
